import type { InvoiceModel, InvoicesRepository } from '@/Invoices/domain'
import {
  FilterResultModel,
  HttpModel,
  IFile,
  PaginationModel,
  edenredProducts,
} from '@/Shared/domain'

interface IInvoices {
  get: (
    page: number,
    numberOfRecordsPerPage: number,
    search?: string,
    filters?: FilterResultModel[],
  ) => Promise<HttpModel<PaginationModel<InvoiceModel>>>
  downloadPdf: (invoicesIds: number[]) => Promise<HttpModel<IFile[]>>
  downloadTransactions: (
    invoicesIds: number[],
    productType: edenredProducts.ticketRestaurant | edenredProducts.ticketGuarderia,
  ) => Promise<HttpModel<IFile>>
}

export const InvoicesContract = (invoicesRepository: InvoicesRepository): IInvoices => ({
  get: async (
    page: number,
    numberOfRecordsPerPage: number,
    search?: string,
    filters?: FilterResultModel[],
  ): Promise<HttpModel<PaginationModel<InvoiceModel>>> =>
    await invoicesRepository.GetInvoicesData(
      page,
      numberOfRecordsPerPage,
      search,
      filters,
    ),
  downloadPdf: async (invoicesIds: number[]): Promise<HttpModel<IFile[]>> =>
    await invoicesRepository.DownloadInvoice(invoicesIds),
  downloadTransactions: async (
    invoicesIds: number[],
    productType: edenredProducts.ticketRestaurant | edenredProducts.ticketGuarderia,
  ): Promise<HttpModel<IFile>> =>
    await invoicesRepository.DownloadTransaction(invoicesIds, productType),
})
